module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "search-all-components col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-xs-12 components-list"
  }, [_c('div', {
    staticClass: "components-list-items"
  }, [_c('loader', {
    attrs: {
      "position": 'fixed',
      "spinLeft": '60%',
      "loading": _vm.loader
    }
  }), _vm._v(" "), _vm._l((_vm.getComponent), function(type, index) {
    return (type.data.length) ? _c('div', {
      key: index,
      staticClass: "all-component row"
    }, [_c('div', {
      staticClass: "col-lg-12 components-title"
    }, [_c('h3', [_vm._v(_vm._s(type.numItems) + " " + _vm._s(_vm.getTranslate(type.terms.name)))])]), _vm._v(" "), _vm._l((type.data.slice(0, 4)), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "list-components col-lg-3 col-md-3 col-xs-6",
        class: {
          'hover-active': _vm.hoverIndex === ((type.type) + "_" + index)
        },
        on: {
          "mouseenter": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.hoverIndex = (type.type) + "_" + index;
          },
          "mouseleave": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.hoverIndex = null;
          }
        }
      }, [_c('div', {
        staticStyle: {
          "position": "relative"
        }
      }, [_c('div', [(type.type !== 'shade') ? _c('router-link', {
        attrs: {
          "tag": "a",
          "to": '/' + type.name + '/' + item.id + '?refere=all-components'
        }
      }, [_c('ComponentPreview', {
        attrs: {
          "component": _vm.mergeComponentWithType(type, item)
        }
      })], 1) : _vm._e(), _vm._v(" "), (type.type === 'shade') ? _c('figure', {
        staticClass: "list-components-figure figure-shade"
      }, [_c('router-link', {
        attrs: {
          "tag": "a",
          "to": '/product/' + item.component.id + '?refere=all-components'
        }
      }, [(item.component.figures && !item.component.figures.small) ? _c('img', {
        staticClass: "grab img-fluid ff-medium svgMeuble center",
        attrs: {
          "src": require("../../../static/img/no_image.jpg")
        }
      }) : _vm._e(), _vm._v(" "), (item.component.figures && item.component.figures.small) ? _c('img', {
        attrs: {
          "src": _vm.getImgPath(item.component.figures.small)
        }
      }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.hoverIndex === ((type.type) + "_" + index)) ? _c('div', {
        staticClass: "forecast-button"
      }, [(_vm.canAddToForecast() && _vm.hasAccessDelete(_vm.forecastFunctionality)) ? _c('span', {
        staticClass: "basket iLineBlock",
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.forecastItem = item;
            _vm.displayForecastModal = true;
          },
          "mouseenter": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.hoverIndexForecast = (type.type) + "_" + index;
          },
          "mouseleave": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.hoverIndexForecast = null;
          }
        }
      }, [_c('ForecastIcon', {
        staticStyle: {
          "height": "20px",
          "margin-bottom": "-2px"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('div', {
        style: ({
          visibility: _vm.hoverIndexForecast === ((type.type) + "_" + index) ? 'visible' : 'hidden'
        })
      }, [_vm._v("\n                                        Add to forecast\n                                    ")])]) : _vm._e()], 1)]), _vm._v(" "), (type.type === 'shade') ? _c('div', {
        staticClass: "bgColor",
        style: (item.properties.colors ? {
          'background-color': item.properties.colors.color.value
        } : '')
      }, [(!item.properties.colors) ? _c('i', {
        staticClass: "far fa-empty-set"
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "typeDetail"
      }, [(type.type !== 'shade') ? _c('h3', [_vm._v(_vm._s(_vm.getTranslate(item.terms.name)))]) : _vm._e(), _vm._v(" "), (type.type === 'shade') ? _c('h3', [_vm._v(_vm._s(_vm.getTranslate(item.component.terms.name)))]) : _vm._e(), _vm._v(" "), (type.type === 'shade') ? _c('p', {
        staticClass: "refProduct"
      }, [(item.properties.number) ? _c('span', [_vm._v(_vm._s(item.properties.number.numb1.value))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("- " + _vm._s(item.terms.name ? _vm.getTranslate(item.terms.name) : item.name))]), _vm._v(" "), _c('span', {
        staticClass: "block"
      }, [_vm._v("(" + _vm._s(item.properties.reference.client_ref1.value) + ")")])]) : _vm._e(), _vm._v(" "), (type.type !== 'shade') ? _c('p', {
        staticClass: "refProduct"
      }, [(item.infosArticle.client_ref1) ? _c('span', [_vm._v(_vm._s(item.infosArticle.client_ref1.componentProperty.value) + " -")]) : _vm._e(), _vm._v(" "), (item.infosArticle.diam_ref1) ? _c('span', [_vm._v(_vm._s(item.infosArticle.diam_ref1.componentProperty.value))]) : _vm._e()]) : _vm._e()])])
    }), _vm._v(" "), (type.data.length > 4) ? _c('div', {
      staticClass: "btn-next"
    }, [(type.type !== 'shade') ? _c('router-link', {
      attrs: {
        "tag": "a",
        "to": '/catalog?&offset=1&type=' + type.type + '&search=' + _vm.$route.query.search + '&refere=all-components'
      }
    }, [_c('i', {
      staticClass: "fas fa-chevron-right fa-4x"
    })]) : _vm._e(), _vm._v(" "), (type.type === 'shade') ? _c('router-link', {
      attrs: {
        "tag": "a",
        "to": '/shades?&offset=1&type=' + type.type + '&search=' + _vm.$route.query.search + '&refere=all-components'
      }
    }, [_c('i', {
      staticClass: "fas fa-chevron-right fa-4x"
    })]) : _vm._e()], 1) : _vm._e()], 2) : _vm._e()
  })], 2)])]), _vm._v(" "), (_vm.displayForecastModal) ? _c('ForecastItemModal', {
    attrs: {
      "item": _vm.forecastItem
    },
    on: {
      "close": function($event) {
        _vm.displayForecastModal = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f92c61c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/SearchAllComponents.vue
// module id = 3327
// module chunks = 0